export class Settings {
}